import type { Milliseconds, Pixels, Seconds } from '@lemonade-hq/ts-helpers';
import { spacing } from '@lemonade-hq/uniclient-theme';
import { ICON_ANIMATION_DURATION } from './components/AnimatedIcons';

const MULTIPLIER = 1;

// Animations
export const SUB_ITEMS_WRAPPER_EXPANSION_DURATION: Seconds = 0.3 * MULTIPLIER;
export const SUB_ITEMS_OPACITY_TRANSITION_DURATION: Seconds = 0.1 * MULTIPLIER;
export const LINE_ANIMATION_DURATION: Seconds = 0.2 * MULTIPLIER;
export const COMPLETED_ANIMATION_DURATION: Seconds = 0.8 * MULTIPLIER;

// All progress items fade in and out when they are added or removed from the DOM
export const FADE_IN_DURATION: Seconds = 0.3 * MULTIPLIER;
export const FADE_OUT_DURATION: Seconds = 0.2 * MULTIPLIER;

export const TEXT_COLOR_TRANSITION_DURATION: Seconds = 1.2 * MULTIPLIER;
export const TEXT_PINK_HOLD_DURATION: number = 0.5 * MULTIPLIER;
export const LEVEL_ONE_ANIMATION_DELAY: Seconds = (ICON_ANIMATION_DURATION + LINE_ANIMATION_DURATION) * MULTIPLIER;
export const TIME_TO_MAKE_ANIMATION_LOOK_GOOD = 0.1 * MULTIPLIER;
export const ITEM_CONTAINER_OPACITY_DELAY: Seconds = 0.5 * MULTIPLIER;

// Delays for going backwards
export const DELAY_PREVIOUS_ITEM_DURATION: Milliseconds = 300;

// Styles
export const LEVEL_ONE_GAP = spacing.s20;
export const LEVEL_ONE_TO_TWO_GAP = spacing.s12;
export const LEVEL_TWO_GAP = spacing.s08;
export const TEXT_LINE_HEIGHT = 1.47;
export const TEXT_FONT_SIZE = '14px';
export const ITEM_HEIGHT: Pixels = 22;
